export type GlobalOperators = 'equals' | 'doesNotEqual';

export type TextOperators = 'contains' | 'doesNotContain';

export type IpOperators = 'isInIpRange' | 'isNotInIpRange';

export type StringOperators =
  | 'matchesRegex'
  | 'doesNotMatchRegex'
  | 'matchesWildcard'
  | 'doesNotMatchWildcard';

export type EmptyOperator = 'equalsUndefined';

export type NullOperator = 'equalsNull' | 'equalsNotNull';

export type NumericOperators =
  | 'greaterThan'
  | 'greaterThanOrEqual'
  | 'lessThan'
  | 'lessThanOrEqual';

export type DateOperators =
  | 'greaterThan'
  | 'greaterThanOrEqual'
  | 'lessThan'
  | 'lessThanOrEqual';

export type ListOperators = 'contains' | 'doesNotContain';

export type DateRangeOperators = 'past' | 'next' | 'between' | 'range';

export type KeyValueOperators = 'containKeyValue' | 'doNotContainKeyValue';

export type AllOperators =
  | DateOperators
  | DateRangeOperators
  | EmptyOperator
  | GlobalOperators
  | IpOperators
  | ListOperators
  | NullOperator
  | NumericOperators
  | StringOperators
  | KeyValueOperators
  | TextOperators;

export interface Operator {
  label: string;
  type: AllOperators;
}

const greaterLesserOperators: Operator[] = [
  {
    label: 'greater than',
    type: 'greaterThan',
  },
  {
    label: 'greater than or equal to',
    type: 'greaterThanOrEqual',
  },
  {
    label: 'less than',
    type: 'lessThan',
  },
  {
    label: 'less than or equal to',
    type: 'lessThanOrEqual',
  },
];

const containsOperators: Operator[] = [
  {
    label: 'contains',
    type: 'contains',
  },
  {
    label: 'does not contain',
    type: 'doesNotContain',
  },
];

export const globalOperators: Operator[] = [
  {
    label: 'is',
    type: 'equals',
  },
  {
    label: 'is not',
    type: 'doesNotEqual',
  },
];

export const recordListOperators: Operator[] = [...containsOperators];

export const listOperators: Operator[] = [
  {
    label: 'contain',
    type: 'equals',
  },
  {
    label: 'do not contain',
    type: 'doesNotEqual',
  },
];

export const stringOperators: Operator[] = [
  {
    label: 'matches regular expression',
    type: 'matchesRegex',
  },
  {
    label: 'does not match regular expression',
    type: 'doesNotMatchRegex',
  },
  {
    label: 'matches wildcard pattern',
    type: 'matchesWildcard',
  },
  {
    label: 'does not match wildcard pattern',
    type: 'doesNotMatchWildcard',
  },
];

export const textOperators: Operator[] = [
  {
    label: 'contains phrase starting with',
    type: 'contains',
  },
  {
    label: 'does not contain phrase starting with',
    type: 'doesNotContain',
  },
];

export const ipOperators: Operator[] = [
  {
    label: 'is in IP range',
    type: 'isInIpRange',
  },
  {
    label: 'is not in IP range',
    type: 'isNotInIpRange',
  },
];

export const emptyOperator: Operator[] = [
  {
    label: 'is empty',
    type: 'equalsUndefined',
  },
];

export const nullOperator: Operator[] = [
  {
    label: 'is empty',
    type: 'equalsNull',
  },
  {
    label: 'is not empty',
    type: 'equalsNotNull',
  },
];

export const numericOperators: Operator[] = [...greaterLesserOperators];

export const dateOperators: Operator[] = [...greaterLesserOperators];

export const dateRangeOperators: Operator[] = [
  {
    label: 'past',
    type: 'past',
  },
  {
    label: 'next',
    type: 'next',
  },
  {
    label: 'between',
    type: 'between',
  },
];

export const keyValueOperators: Operator[] = [
  {
    label: 'contain',
    type: 'containKeyValue',
  },
  {
    label: 'do not contain',
    type: 'doNotContainKeyValue',
  },
];

export const allOperators: Operator[] = [
  ...globalOperators,
  ...textOperators,
  ...emptyOperator,
  ...numericOperators,
  ...dateOperators,
  ...dateRangeOperators,
  ...listOperators,
];
